module.exports = __webpack_public_path__ + "img/normas.a7dec18e.jpg";